import { CuisineInterface } from "../_cuisines";
import fetchUtil from "./_fetchUtil";

export default class Http {
    private _fetch = new fetchUtil()
    private _baseUrl = `/api/cuisines`

    getAll = (): Promise<Response> => this._fetch.get(`${this._baseUrl}`)
    post = (): Promise<Response> => this._fetch.post(`${this._baseUrl}`)

    get = (id: CuisineInterface['id']): Promise<Response> => this._fetch.get(`${this._baseUrl}/${id}`)
    put = (id: CuisineInterface['id'], data: Partial<CuisineInterface>): Promise<Response> => this._fetch.put(`${this._baseUrl}/${id}`, data)

    uploadImage = (id: CuisineInterface['id'], form: FormData): Promise<Response> => this._fetch.upload(`${this._baseUrl}/${id}/image`, form)
    removeImage = (id: CuisineInterface['id']) => this._fetch.delete(`${this._baseUrl}/${id}/image`)


    delete = (id: CuisineInterface['id']): Promise<Response> => this._fetch.delete(`${this._baseUrl}/${id}`)

}